import { ProductFilters, Sorting } from '@typings';
import { createAction } from 'typesafe-actions';

export const resetFilters = createAction('products/FILTERS_RESET')();

export const updateFilters = createAction('products/FILTERS_UPDATE')<{
  filters: ProductFilters;
  preserveCurrent?: boolean;
}>();

export const setExpandedProductFilters = createAction('products/SET_EXPANDED_FILTERS')<Record<string, boolean>>();
export const setProductSortingValue = createAction('products/SORTING_VALUE_SET')<Sorting.FieldValue>();
export const setProductSortingDefaultValue = createAction('products/SORTING_DEFAULT_VALUE_SET')<Sorting.FieldValue>();
